import { ExchangeBoxItem } from "@/components/dashboard/ExchangeBoxItem"
import { components, useExchangeBox } from "@usher/pe-client-front-end-lib"
import { FormattedMessage, useIntl } from "react-intl"
import { Button } from "../Button"

export const ExchangeBox = () => {
  const intl = useIntl()
  const { selectFiat, selectCrypto, fetchPrices } = useExchangeBox()

  return (
    <div className="markets-actions__exchange mr-xl">
      <h3 className="h3 markets-actions__title mb-xs">
        <FormattedMessage id="exchange" />
      </h3>
      <div className="markets-actions__form box box-blue">
        <div className="markets-actions-form__iputs-wrapper">
          <label className="markets-actions__form-desc">
            <FormattedMessage id="i_have" />
          </label>
          <ExchangeBoxItem selector={selectFiat} />
          <label className="markets-actions__form-desc">
            <FormattedMessage id="i_want" />
          </label>
          <ExchangeBoxItem selector={selectCrypto} />
        </div>
        <components.Timer onUpdate={fetchPrices} className="markets-actions__form-descr" text={intl.formatMessage({ id: "recalculated_in" })} />
        {/* <Button onClick={onExchange} style={{ width: "100%" }} color="secondary">
          <FormattedMessage id="exchange" />
        </Button> */}
        <Button style={{ width: "100%" }} color="secondary">
          <FormattedMessage id="exchange" />
        </Button>
      </div>
    </div>
  )
}
